/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：932
 */

module.exports = {
  container: "SelectedWidget_container__1_nzS"
}
